import type { ComponentProps } from "react";
import { Slot } from "radix-ui";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

const styles = tv({
  base: "notification-bar -mx-6 flex justify-center border-b-2 border-banner-border bg-banner-background px-6 py-3 text-banner-foreground md:-mx-16 md:items-center md:py-4",
  variants: {
    color: {
      success: "border-green-100 bg-green-50 text-green-800",
    },
  },
});

type NotificationBarProps = ComponentProps<"div"> & {
  asChild?: boolean;
} & VariantProps<typeof styles>;

export const NotificationBar = ({
  className,
  asChild,
  color,
  ...props
}: NotificationBarProps) => {
  const Component = asChild ? Slot.Root : "div";

  return <Component className={styles({ color, className })} {...props} />;
};
